import React from "react";
import "./ProductDisplay.css";
import { Product } from "../../Interfaces/Product";
import AddToCartButton from "./AddToCartButton";
import { FundraiserParticipantShop } from "../../Interfaces/FundraiserRole";
import { CartItem, generateUniqueId } from "../../Interfaces/Types";
import config from "../../config";

const ProductDisplay: React.FC<{
  product: Product;
  participant: FundraiserParticipantShop;
}> = ({ product, participant }) => {
  const product_item: CartItem = {
    id: generateUniqueId(),
    sku: product.sku,
    name: product.item_display_name,
    price: parseFloat(product.item_cost),
    quantity: 1,
    image: `${config.BACKEND_BASE_IMAGE_LOCATION}${product.image_url}` || "",
  };

  return (
    <div className="participant-shop-product-display">
      <img
        src={`${config.BACKEND_BASE_IMAGE_LOCATION}${product.image_url}` || ""}
        alt={product.item_display_name}
        className="participant-shop-product-display-image"
      />
      <div className="participant-shop-product-display-info">
        <p className="participant-shop-product-display-name">
          {product.item_display_name}
        </p>
        <p className="participant-shop-product-display-price">
          ${parseFloat(product.item_cost).toFixed(2)}
        </p>
        {!product.customizable && (
          <div className="participant-shop-product-display-button-container">
            <AddToCartButton item={product_item} participant={participant} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductDisplay;
